// NOTE: NSAI-7890 — the `<main>` landmark's id, the target of the skip link.
export const MAIN_CONTENT_ID = "main-content";
